import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    preqcRejectList: {},
    preqcNotification: {},
};

const PreqcRejectSlice = createSlice({
    name: 'preqclist',
    initialState,
    reducers: {
        setPreqcRejectList(state, action) {
            state.preqcRejectList = action.payload;
        },
        setToast(state, action) {
            state.preqcNotification = action.payload;
        },
        // setToast(state, action) {
        //     state.notification = action.payload;
        // },

    },
});



export const PreqcRejectListApi = (tokendata, page, limit,search, journalId) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitManuScriptList?page=${page}&limit=${limit}&search=${search}&type=preqc_rejected&journal_uuid=${journalId}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setPreqcRejectList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}


export const { setPreqcRejectList, setToast } = PreqcRejectSlice.actions;
const PreqcRejectReducer = PreqcRejectSlice.reducer;

export default PreqcRejectReducer;
